<template>
    <div class="animated fade-in">

        <h1 class="display-4 font-weight-lighter">
            Notification Messages
            <div class="d-inline-block float-right">
                <b-button-group class="float-left mr-2">
                    <b-button variant="outline-dark" squared v-b-tooltip.hover title="Create Global Message" @click="showMessage()"><font-awesome-icon :icon="['fal','plus']"></font-awesome-icon> Global</b-button>
                    <b-button variant="outline-dark" squared v-b-tooltip.hover title="Create Order Message" @click="showMessage('order')"><font-awesome-icon :icon="['fal','plus']"></font-awesome-icon> Order</b-button>
                    <b-button variant="outline-dark" squared v-b-tooltip.hover title="Create Estimate Message" @click="showMessage('estimate')"><font-awesome-icon :icon="['fal','plus']"></font-awesome-icon> Estimate</b-button>
                    <b-button variant="outline-dark" squared v-b-tooltip.hover title="Notifications" to="/notifications"><font-awesome-icon :icon="['fal','list']"></font-awesome-icon></b-button>
                </b-button-group>
                <b-dropdown class="float-left" text="View Examples">
                    <b-dropdown-item @click="viewExample('GeneralNotification')">General Notification</b-dropdown-item>
                    <b-dropdown-item @click="viewExample('OrderStatusChanged')">Order Status Changed</b-dropdown-item>
                    <b-dropdown-item @click="viewExample('EstimateStatusChanged')">Estimate Status Changed</b-dropdown-item>
                </b-dropdown>
            </div>
        </h1>

        <notification-message-table :refresh="refresh" @onRefreshed="refresh = false"></notification-message-table>

        <c-modal scrollable :show.sync="example_show" title="Example" size="lg">
            <b-overlay :show="example_loading">
                <iframe frameborder="0" :src="example_src" width="100%" height="600"></iframe>
            </b-overlay>
            <template #footer=""><span></span></template>
        </c-modal>

        <c-modal scrollable :show.sync="message_show" :title="'New ' + (this.message_type ? this.message_type.split('\\').pop() : 'Global') + ' Message'" size="lg">
<!--            <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">-->
<!--                <b-button-group>-->
<!--                    <b-button squared variant="outline-dark" :class="{ 'text-white': isActive.bold(), 'btn-dark': isActive.bold() }" @click="commands.bold">-->
<!--                        <i></i>-->
<!--                    </b-button>-->
<!--                </b-button-group>-->
<!--            </editor-menu-bar>-->
<!--            <editor-content class="border" :editor="editor" />-->
            <b-select class="mb-2" v-if="isOrderType" v-model="message_filter" :options="orderFilters"></b-select>
            <b-textarea v-model="message_message" placeholder="Message" style="height: 300px"></b-textarea>
            <template #footer="">
                <b-button-group class="float-left mr-2">
                    <b-button variant="outline-success" squared @click="newGlobalMessage"><font-awesome-icon :icon="['fal','save']"></font-awesome-icon></b-button>
                </b-button-group>
            </template>
        </c-modal>

    </div>
</template>

<script>
  import Notification from "../../models/Notification";
  import ToastNotifications from "../../components/shared/mixins/ToastNotifications";
  import NotificationMessageTable from "../../components/notifications/NotificationMessageTable";
  import NotificationMessage from "../../models/NotificationMessage";
  //import { Editor, EditorContent, EditorMenuBar } from 'tiptap';
  // import {
  //   Blockquote, CodeBlock, HardBreak, Heading, OrderedList,
  //   BulletList, ListItem, TodoItem, TodoList, Bold, Code,
  //   Italic, Link, Strike, Underline, History,
  // } from 'tiptap-extensions';

  export default {
    name: 'NotificationMessageIndex',
    components: {NotificationMessageTable/*, EditorContent, EditorMenuBar*/},
    mixins: [ToastNotifications],
    data() {
      return {
        refresh: false,

        example_show: false,
        example_loading: true,
        example_src: null,

        message_type: null,
        message_show: false,
        editor: null,
        message_filter: null,
        message_message: null,
      };
    },
    computed: {
      isOrderType() {
        return this.message_type === NotificationMessage.orderStatusChanged;
      },
      orderFilters() {
        return [{value: null, text: '-- Assign a status --'}].concat(NotificationMessage.orderStatusFilters.map(filter => ({value: filter, text: filter})));
      }
    },
    methods: {
      viewExample(type) {
        this.example_loading = true;
        this.example_show = true;
        Notification.api().example(type).then((response) => {
          let data = response.response.data;
          this.example_src = 'data:text/html;base64,' + btoa(unescape(encodeURIComponent(data)));
          let file = new Blob([data], {type: 'text/html'});
          let urlCreator = window.URL || window.webkitURL;
          let url = urlCreator.createObjectURL(file);
          this.example_src = url;
          this.example_loading = false;
        });
      },
      newGlobalMessage() {
        return NotificationMessage.api().create({
          type: this.message_type,//NotificationMessage.generalNotification,
          filter_value: this.message_filter,
          message: this.message_message
        }).then(() => {
          this.message_show = false;
          this.message_message = null;
          this.message_filter = null;
          this.refresh = true;
        });
      },
      showMessage(type) {
        switch(type) {
          case 'order':
            this.message_type = NotificationMessage.orderStatusChanged;
            break;
          case 'estimate':
            this.message_type = NotificationMessage.estimateStatusChanged;
            break;
          default:
            this.message_type = null;
            break;
        }
        this.message_show = true;
      }
    },
    /*mounted() {
      this.editor = new Editor({
        extensions: [
          new Blockquote(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new BulletList(),
          new OrderedList(),
          new ListItem(),
          new TodoItem(),
          new TodoList(),
          new Bold(),
          new Code(),
          new Italic(),
          new Link(),
          new Strike(),
          new Underline(),
          new History(),
        ],
        content: this.message_message
      });
    },
    beforeDestroy() {
      this.editor.destroy();
    },*/
  }
</script>